<template>
  <td class="symbol"
      :colspan="1"
      :style="calcStyle() "
      :class="{'selected': config.selected}"
      @mouseenter="onmouseenter"
      @click="onclick"
      @contextmenu="oncontextmenu"
      @mouseover="onmouseover"
      @mouseleave="onmouseleave"
  >
    <div class="symbol-container">
      <div class="component root">
        {{ chord.root ? chord.root[0] : '' }}<sup class="accidental">{{ getAccidental(chord.root) }}</sup>
      </div>
      <div class="component chord_type">
        {{ chord.type }}
      </div>
      <div class="component extension" v-if=hasExtension>
      </div>
      <div class="component slash" v-if="hasBass && config.showBass">
        /
      </div>
      <div class="component bass" v-if="hasBass && config.showBass">
        {{ chord.bass[0] }}<sup class="accidental">{{ getAccidental(chord.bass) }}</sup>
      </div>
      <button class="remove" v-if="config.showRemoveButton"></button>
    </div>
    <Staff v-if="config.showVoicing && chord.noteNames().length" :uuid="uuid" :notes="chord.noteNames()"/>
  </td>
</template>

<script>

import { Chord } from '@/utils/Chord'
import Staff from '@/components/Staff'

function DefaultChordSymbolConfig () {
  return {
    selected: false,
    showBass: true,
    showRemoveButton: false,
    showVoicing: true
    // duration: 4,
    // beginPosition: [0, 0],
    // colorScheme: null,
    // borderScheme: null
  }
}

export default {
  name: 'ChordSymbol',
  setup () {
    return {
      Chord: Chord // Chord builder from Chord.js
    }
  },
  components: {
    Staff
  },
  props: {
    uuid: {
      type: String
    },
    chord: {
      default: Chord
    },
    config: {
      default: DefaultChordSymbolConfig
    }
  },
  emits: [
    'update_selection',
    'remove_chord'
  ],
  data () {
    return {
      selected: this.config.selected,
      showVoicing: false
    }
  },
  computed: {
    hasExtension: function () {
      return false
    },
    hasBass: function () {
      return !!this.chord.bass
    },
    noteNames: function () {
      return this.chord.noteNames()
    }
  },
  methods: {
    onmouseenter (e) {
      if (e.buttons & 1) {
        // console.log(e, e.buttons)
        this.$emit('update_selection', { uuid: this.uuid })
      }
    },
    onclick (e) {
      this.$emit('update_selection', { uuid: this.uuid })
    },
    getAccidental (noteStr) {
      if (!noteStr) {
        return ''
      }
      for (const accidental of '# b x bb'.split(' ')) {
        if (noteStr.match(accidental)) {
          return accidental
        }
      }
      return ''
    },
    oncontextmenu (e) {
      e.preventDefault()
      if (e.buttons & 1) {
        this.$emit('remove_chord', { uuid: this.uuid })
      }
    },
    onmouseover (e) {
      if (e.altKey ^ this.config.showVoicing) {
        this.showVoicing = !!e.altKey
      }
    },
    onmouseleave (e) {
      this.showVoicing = false
    },
    calcStyle () {
      // eslint-disable-next-line quote-props
      const style = { 'border-left': '2px solid blue' }
      if (!this.chord.root) {
        style['border-left'] = 'none'
        style['border-right'] = 'none'
      }
      return style
    }
  }
}

</script>

<style scoped>
.symbol:not(.staff) {
  position: relative;
  /*box-sizing: border-box;*/
  background: #fafafa33;
  border: 2px dashed transparent;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 6px;
  letter-spacing: -.03rem;
  white-space: nowrap;
  border-radius: 3px;
  font-size: max(30px, 2rem);
  /*transition: all .08s ease-in-out;*/
  --mygap: inherit;
  overflow: visible;
  height: 160px;
}

.symbol-container {
  align-items: center;
  gap: 1%;
  display: flex;
  min-height: 35px;
}

.symbol:not(.staff):hover {
  background: #D4D4D4A0;
  /*background: #fafafa;*/

  outline: none;
  /*z-index: 1;*/
}

.symbol:not(.staff).selected {
  background: #c5c5c560;
  border: 2px dashed blue;
  outline: none;
  /*z-index: 1;*/
}

.symbol:not(.staff):focus {
  /*border: 2px dashed blue;*/
  outline: none;
  /*z-index: 1;*/
}

.accidental {
  font-size: .6em;
}

.component, .slash, .bass {
  /*border: 1px dashed red;*/
  display: block;
  user-select: none;
  user-focus: none;
  overflow: visible;
  position: relative;
  text-wrap: avoid;
  z-index: -1;
}

.chord_type {
  transform: translateY(-15%);
  font-size: .7em;
}

.extension {
  font-size: .6em;
  /*vertical-align: center;*/
  /*text-align: ;*/
  padding: 2%;
  border: .09rem solid black;
  border-bottom: none;
  border-top: none;
  border-radius: 30%;
}

.slash, .bass {
  transform: translateY(15%);
}

.bass {
  font-size: 0.6em;
}

sup * {
  font-size: 20px;
}

.remove {
  position: absolute;
  font-size: .8em;
  text-align: center;
  justify-content: center;
  align-content: center;
  padding: 1px;
  margin-top: 3px;
  margin-right: 3px;
  height: 6px;
  width: 12px;
  /*margin: 0;*/
  background: gray;

  right: 0;
  top: 0;

  outline: none;
  flex: 0;
  border-radius: var(--mygap);
  border: 0;
  color: gray;
}

.remove:active {
  filter: brightness(140%);
}

.remove::before {
  content: '';
  width: 6px;
  height: 3px;
  right: 3px;
  top: 1px;
  /*background-color: cyan;*/
  position: absolute;
  box-shadow: #fafafa 0 0 0 4px;
  border-radius: 3px;
}

.remove::before:hover {
  background: #fafafa;
}

.symbol .staff {
  /*visibility: hidden;*/
  position: absolute;
  /*opacity: 0;*/
  z-index: 2;
}

.symbol:hover .staff {
  visibility: visible;
  /*opacity: 100%;*/
}

</style>
